/**
 * Free Gift Feature
 * Adds/removes free gifts based on cart item count
 * Updated: Replaced blocking alert() with toast notifications
 */
(function() {
  'use strict';

  const CONFIG = window.FREE_GIFT_CONFIG || {
    giftPropertyKey: '_free_gift',
    gifts: [
      { productId: 9393299063133, variantId: 51751225917789, requiredItems: 2 },
      { productId: 15861617590621, variantId: 63115987911005, requiredItems: 3 }
    ]
  };

  const giftProductIds = new Set(CONFIG.gifts.map(g => g.productId));
  const manuallyRemoved = new Set();
  let isProcessing = false;
  let lastCount = 0;
  let selfTriggered = false;
  let sections = null;

  // Toast notification system (non-blocking alternative to alert)
  const toast = {
    container: null,

    init() {
      if (this.container) return;
      this.container = document.createElement('div');
      this.container.id = 'free-gift-toast';
      this.container.setAttribute('role', 'alert');
      this.container.setAttribute('aria-live', 'polite');
      Object.assign(this.container.style, {
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%) translateY(100px)',
        background: '#333',
        color: '#fff',
        padding: '12px 24px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        zIndex: '99999',
        opacity: '0',
        transition: 'transform 0.3s ease, opacity 0.3s ease',
        maxWidth: '90vw',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
      });
      document.body.appendChild(this.container);
    },

    show(message, duration = 4000) {
      this.init();
      this.container.textContent = message;
      this.container.style.transform = 'translateX(-50%) translateY(0)';
      this.container.style.opacity = '1';

      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => this.hide(), duration);
    },

    hide() {
      if (!this.container) return;
      this.container.style.transform = 'translateX(-50%) translateY(100px)';
      this.container.style.opacity = '0';
    }
  };

  const getCount = (items) => {
    let c = 0;
    for (const item of items) if (!giftProductIds.has(item.product_id)) c += item.quantity;
    return c;
  };

  /**
   * Déduplique les /cart.js SIMULTANÉS.
   *
   * Mesuré au trace : 4 requêtes /cart.js sur un seul chargement de PDP, dont deux
   * strictement concurrentes (les écouteurs cart:updated / cart:rerender /
   * theme:cart:change déclenchent process() plusieurs fois de suite).
   *
   * On ne met VOLONTAIREMENT aucun TTL : la promesse est relâchée dès qu'elle est
   * résolue. Les gardes de passage en caisse (submit/click) doivent lire un panier
   * frais — un cache même court pourrait autoriser un checkout sur des données
   * périmées juste après une modification du panier.
   */
  let cartInFlight = null;
  const getCart = () => {
    if (cartInFlight) return cartInFlight;
    cartInFlight = fetch('/cart.js')
      .then(r => r.json())
      .finally(() => { cartInFlight = null; });
    return cartInFlight;
  };

  const getSections = () => {
    if (sections) return sections;
    sections = [];
    const d = document.querySelector('[data-cart-drawer]');
    const p = document.querySelector('[data-cart-page]');
    if (d?.dataset.sectionId) sections.push(d.dataset.sectionId);
    if (p?.dataset.sectionId) sections.push(p.dataset.sectionId);
    return sections;
  };

  const updateDOM = (data) => {
    if (!data?.sections) return;
    for (const sel of ['[data-cart-drawer]', '[data-cart-page]']) {
      const c = document.querySelector(sel);
      if (!c) continue;
      const html = data.sections[c.dataset.sectionId];
      if (!html) continue;
      const t = document.createElement('template');
      t.innerHTML = html;
      for (const s of ['[data-cart-products]', '[data-cart-button-container]', '[data-progress-bar-message]', '[data-cart-header]']) {
        const n = t.content.querySelector(s), o = c.querySelector(s);
        if (n && o) o.innerHTML = n.innerHTML;
      }
    }
  };

  const updateUI = (count) => {
    document.querySelectorAll('[data-cart-count-badge], [data-cart-count]').forEach(el => el.textContent = count);
    document.querySelectorAll('custom-progress-bar').forEach(bar => bar.value = count);

    // Block checkout if only free gifts in cart
    const checkoutBtns = document.querySelectorAll('[name="checkout"], [href*="/checkout"], .checkout-button, [data-checkout-button]');
    checkoutBtns.forEach(btn => {
      btn.disabled = count === 0;
      if (btn.tagName === 'A') btn.style.pointerEvents = count === 0 ? 'none' : '';
    });
  };

  // Intercept checkout form submissions (non-blocking)
  document.addEventListener('submit', (e) => {
    if (e.target.action?.includes('/cart') || e.target.querySelector('[name="checkout"]')) {
      getCart().then(cart => {
        if (getCount(cart.items) === 0 && cart.items.length > 0) {
          e.preventDefault();
          toast.show('Veuillez ajouter des articles pour bénéficier des cadeaux offerts.');
        }
      });
    }
  }, true);

  // Intercept direct checkout links (non-blocking)
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="/checkout"]');
    if (link) {
      // preventDefault() est synchrone : la navigation du navigateur est annulée
      // DÈS MAINTENANT, et c'est ce callback qui devient seul responsable de la
      // déclencher. Toute branche qui n'y mène pas laisse un bouton mort.
      e.preventDefault();
      getCart()
        .then(cart => {
          if (getCount(cart.items) === 0 && cart.items.length > 0) {
            toast.show('Veuillez ajouter des articles pour bénéficier des cadeaux offerts.');
          } else {
            window.location = link.href;
          }
        })
        .catch(() => {
          // Panier illisible (hors ligne, 5xx, réponse malformée) : on LAISSE PASSER.
          // Sans ce catch, un échec réseau annulait la navigation sans rien relancer :
          // le bouton « Passer commande » devenait inerte, sur le chemin d'achat.
          // En cas de doute, mieux vaut laisser filer vers la caisse — Shopify
          // recalcule et valide le panier de toute façon.
          window.location = link.href;
        });
    }
  }, true);

  async function cartOp(endpoint, body) {
    selfTriggered = true;
    try {
      const r = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...body, sections: getSections() })
      });
      if (r.ok) {
        const d = await r.json();
        // Le panier vient de changer : on invalide toute lecture /cart.js encore en vol,
        // sinon le prochain getCart() pourrait résoudre sur un panier d'avant la mutation.
        cartInFlight = null;
        updateDOM(d);
        // Dispatch cart:updated event after successful cart operation
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        return d;
      }
    } catch {} finally { selfTriggered = false; }
    return null;
  }

  async function process(prefetchedCart) {
    if (isProcessing || selfTriggered) return;
    isProcessing = true;

    try {
      const cart = prefetchedCart || await getCart();
      const count = getCount(cart.items);
      const inCart = new Map(cart.items.map(i => [i.product_id, i]));

      let changed = false;

      for (const g of CONFIG.gifts) {
        const present = inCart.get(g.productId);

        // Track manual removal
        if (!present && count >= g.requiredItems && count <= lastCount) manuallyRemoved.add(g.productId);
        if (count > lastCount) manuallyRemoved.delete(g.productId);

        // Add gift
        if (count >= g.requiredItems && !present && !manuallyRemoved.has(g.productId)) {
          await cartOp('/cart/add.js', { items: [{ id: g.variantId, quantity: 1, properties: { [CONFIG.giftPropertyKey]: 'true' } }] });
          changed = true;
        }
        // Remove gift
        else if (count < g.requiredItems && present) {
          await cartOp('/cart/change.js', { id: present.key, quantity: 0 });
          changed = true;
        }
      }

      lastCount = count;

      if (changed) {
        const fresh = await getCart();
        updateUI(getCount(fresh.items));
      } else {
        updateUI(count);
      }
    } catch (e) { console.error('Free gift:', e); }

    isProcessing = false;
  }

  /**
   * Les trois évènements ci-dessous sont souvent émis en rafale pour UNE seule
   * modification du panier (le thème en émet plusieurs, et cartOp() en réémet un).
   * `isProcessing` empêche le chevauchement mais pas les exécutions successives :
   * mesuré, cela donnait deux process() complets à 55 ms d'intervalle, donc deux
   * /cart.js. On regroupe la rafale en un seul passage.
   *
   * 50 ms : assez court pour rester imperceptible (process() est déjà asynchrone),
   * assez long pour absorber une rafale d'évènements d'un même tick.
   */
  let handleTimer = null;
  const handle = () => {
    if (selfTriggered) return;
    clearTimeout(handleTimer);
    handleTimer = setTimeout(() => process(), 50);
  };

  ['cart:updated', 'cart:rerender', 'theme:cart:change'].forEach(e => document.addEventListener(e, handle));

  setTimeout(async () => {
    try {
      const cart = await getCart();
      lastCount = getCount(cart.items);
      for (const g of CONFIG.gifts) if (cart.items.some(i => i.product_id === g.productId)) manuallyRemoved.delete(g.productId);
      // on réutilise le panier déjà chargé ci-dessus : sans cet argument,
      // process() relançait immédiatement un second /cart.js séquentiel.
      process(cart);
    } catch {}
  }, 50);
})();
